import React, { useState, useEffect } from 'react';
import MobileHeader from "../../layout/mobile/MobileHeader";
import MobileCarouselBanner from "../../sliders/Mobile";
import Announcement from "../../sliders/Mobile/Announcement";
import GameNavIcon from "../../navigation/mobile/GameNavIcon";
import Footer from "../../layout/mobile/Footer";
import ScrollBanner from "../../common/mobile/ScrollBanner";
import FeatureGames from "../../sliders/Mobile/FeatureGames";
import GuestToolbar from "../../layout/mobile/GuestToolbar";
import Toolbar from "../../navigation/mobile/Toolbar";
import Splash from '../../../splash/Splash';
import NewsPopUp from './common/NewsPopUp';
import RegisterPopUp from './common/RegisterPopUp';
import FreeSpinLauncher from '../../../free-spin/FreeSpinLauncher';

function Home({globalData}) {
    const [isLoggedIn] = useState(!!localStorage.getItem('token'));
   
    const [showPopup, setShowPopup] = useState(false);
    const [regshowPopup, setSreghowPopup] = useState(false);

    useEffect(() => {
        
        if (localStorage.getItem("popup") === "1") {
            setShowPopup(true);
        }
        if (localStorage.getItem("regPopup") === "1") {
            setSreghowPopup(true);
        }
        
    }, []);

   let systemNotice = globalData?.general?.system_notice || false;

    return (
        <div className="main-router-wrapper">
            <MobileHeader marketBlock={globalData.marketBlock || []} />
            <div className="wrap">
                <div className="content">
                    <MobileCarouselBanner slidersMain={globalData.sliders?.main || []} />
                    <Announcement globalData={globalData} />
                    <GameNavIcon 
                        marketBlock={globalData.marketBlock || []} 
                        featuredGames={globalData.sliders?.feature || []}
                    />
                    <ScrollBanner slidersFavourite={globalData.sliders?.favourite || []}  />
                    <FeatureGames  slidersFeatures={globalData.sliders?.feature || []}  />
					{showPopup && systemNotice && <NewsPopUp notice={systemNotice} />}
                    {showPopup && <RegisterPopUp />}
                </div>
            </div>
            <Footer />
            {isLoggedIn ? <Toolbar /> : <GuestToolbar />}
            {/* Floating Free Spin launcher on left side (visible for all; guests see login/signup prompt) */}
            <FreeSpinLauncher visible={true} label="Free Spin" isLoggedIn={isLoggedIn} />
        </div>
    );
}

export default Home;
